import { Navigate } from 'react-router-dom';
import { ParkingaboLogoHeaderCompact } from 'parkingabo-shared/layout/ParkingaboLogoHeader.tsx';
import { Box, Link, Stack, Typography } from '@mui/material';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { ParkingaboScrollableLayout } from '../../components/layout/ParkingaboLayout.tsx';
import { ParkingaboCardButton } from '../../components/layout/ParkingaboCardButton.tsx';
import { ParkingaboUser } from '../../shared/ParkingaboModels.tsx';
import { HourglassTop } from '@mui/icons-material';

export function OperatorSelectionRoute({
    linkedUsers,
    logout,
}: {
    linkedUsers: ParkingaboUser[];
    logout: () => void;
}) {
    if (linkedUsers.length === 0) {
        return (
            <ParkingaboScrollableLayout>
                <ParkingaboLogoHeaderCompact />
                <Box
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Localized
                        de="Ihr Login ist mit keinem Konto verknüpft."
                        fr="Votre connexion n'est associée à aucun compte."
                        it="Il tuo login non è associato a nessun account."
                        en="Your login is not linked to any account."
                    />
                </Box>
            </ParkingaboScrollableLayout>
        );
    }

    if (linkedUsers.length === 1) {
        return <Navigate to={`${linkedUsers[0].operatorExternalId}`} replace />;
    }

    return (
        <ParkingaboScrollableLayout>
            <ParkingaboLogoHeaderCompact />
            <Box sx={{ padding: theme => theme.spacing(4) }}>
                <Typography
                    variant="h1"
                    sx={[
                        {
                            color: 'inherit',
                        },
                        theme => ({
                            paddingTop: theme.spacing(1),
                            paddingBottom: theme.spacing(3),
                            textAlign: 'center',
                            marginBottom: theme.spacing(1),
                        }),
                    ]}
                >
                    <Localized
                        de="Kontoauswahl"
                        fr="Sélection du compte"
                        it="Selezione conto"
                        en="Account selection"
                    />
                </Typography>
                <Stack spacing={2}>
                    {linkedUsers.map(option => (
                        <ParkingaboCardButton
                            key={option.operatorExternalId}
                            to={`${option.operatorExternalId}`}
                            label={option.operatorName}
                            WarnIcon={
                                option.onboardingCompleteTime
                                    ? undefined
                                    : HourglassTop
                            }
                        />
                    ))}
                </Stack>
                <Box
                    sx={theme => ({
                        paddingTop: theme.spacing(4),
                        textAlign: 'center',
                    })}
                >
                    <Link onClick={logout} underline="always">
                        <Localized
                            de="Abmelden"
                            fr="Déconnecter"
                            it="Esci"
                            en="Logout"
                        />
                    </Link>
                </Box>
            </Box>
        </ParkingaboScrollableLayout>
    );
}
